<template>
  <el-drawer
    title="纠错"
    :visible.sync="drawerFillError"
    direction="btt"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    class="fillError"
    @close="cancelFillError"
  >
    <!--                                :before-close="handleClose"-->
    <div class="drawerMain-box writeNote-box" id="fillError_top">
      <p class="block-label">问题类型：</p>
      <div class="q-type" style="margin-bottom: 20px">
        <el-radio v-model="radioErrorType" label="1" border size="medium"
          >错别字</el-radio
        >
        <el-radio v-model="radioErrorType" label="2" border size="medium"
          >内容错误</el-radio
        >
        <el-radio v-model="radioErrorType" label="3" border size="medium"
          >其他</el-radio
        >
      </div>
      <p class="block-label">问题描述：</p>
      <textarea
        class="writeNote-textarea error-textarea"
        placeholder="请描述您遇到的故障问题"
        v-model="noteTextareaContent"
      ></textarea>
      <div class="upload-img-box">
        <!-- 勿删 截屏功能，暂时隐藏 -->
        <!-- <div class="el-upload-list__item">
          <el-image
            width="30%"
            :src="uploadImg.screenshotData"
            :preview-src-list="uploadImg.srcList"
            crossOrigin="anonymous"
          >
          </el-image>
        </div>-->
        <el-upload
          action=""
          list-type="picture-card"
          multiple=""
          :limit="uploadImg.uploadLimit"
          :file-list="uploadImg.fileList"
          :on-exceed="handleExceed"
          :on-change="handleChange"
          :auto-upload="false"
          accept=".png, .jpg, .jpeg, .gif, .bmp"
          :class="uploadImg.fileList.length >= 3 ? 'upload-limit' : ''"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </div>
      <p class="tips">最多可上传3张图片</p>

      <div class="btn-box">
        <button type="submit" class="btn" @click="submitNote('error')">
          提交
        </button>
        <button
          type="button"
          class="btn cancel-btn"
          @click="cancelFillError"
        >
          取消
        </button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
  export default {
    name: "fillErrorDrawer",
    props: {
      //drawer 是否展示
      drawerFillError: {
        type: Boolean,
        default: false,
      },
      selectedText: {
        type: String,
        default: '',
      },
      // noteTextareaContent: {
      //   type: String,
      //   default: '',
      // },
      noteDrawerType: {
        type: String,
        default: 'add',
      },
    },
    data() {
      return {
        radioErrorType: '1',
        uploadImg: {
          screenshotData: "", // 存储截图数据的变量
          fileList: [], // 已上传文件列表
          uploadLimit: 3, // 上传限制数量
          srcList: [], // 放大后的图片列表
        },
        noteTextareaContent: "",


        textareaContent: ''
      }
    },
    watch: {
      noteTextareaContent() {
        this.textareaContent = this.noteTextareaContent
      }
    },
    methods: {
      changeNoteTextarea() {
        this.$emit('changeNoteTextarea', this.textareaContent)
      },
      // 超出数量限制后的提示
      handleExceed() {
        // this.$message.warning(`当前限制选择 ${this.uploadImg.uploadLimit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        this.$message({
          message: "超出数量限制!",
          type: "error",
          duration: 2000,
          customClass: "myMessageTip", // 自定义类名
        });
      },
      handleChange(file, fileList) {
        this.uploadImg.fileList = JSON.parse(JSON.stringify(fileList));
      },
      // 删除图片
      handleRemove(file) {
        var pic_li = event.target.closest("li");
        this.$confirm("确定要删除当前图片？")
          .then(() => {
            const index = this.uploadImg.fileList.findIndex((item) => {
              return item.uid === file.uid;
            });
            this.uploadImg.fileList.splice(index, 1);
            pic_li.remove();
          })
          .catch(() => {});
      },
      //预览图片
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 点击记笔记中的提交，追加笔记列表
      submitNote(type) {
        if (this.noteTextareaContent == "") {
          this.$message({
            message: "请填写内容后再提交",
            type: "error",
            duration: 2000,
            customClass: "myMessageTip", // 自定义类名
          });
        } else {
          this.$message.success('提交成功！');
          // this.$emit('submitNote', type)
          this.cancelFillError()
          this.noteTextareaContent = "";
          this.uploadImg.fileList = [];
          this.uploadImg.screenshotData = "";
          this.radioErrorType = "1";
        }
      },
      // 滚动弹窗到最顶部
      scrollTop(toId) {
        var box = document.getElementById(toId);
        box.scrollTop = 0; // 设置scrollTop为0，滚动到最顶部
      },
      // 取消写笔记
      cancelFillError(type) {
        this.scrollTop("fillError_top")
        this.$emit('cancelFillError', type)
      },
    }
  }
</script>

<style scoped lang="scss">
/deep/.el-drawer {
  width: 750px;
  height: 600px !important;
  min-height: 400px !important;
  margin: 0 auto !important;
  border-radius: 10px 10px 0 0;
  .el-drawer__header {
    height: 70px;
    margin-bottom: 0;
    border-bottom: 2px solid #E3E3E3;
    padding: 20px 30px 10px;
    color: #DDDDDD;
    text-align: left;
    span {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }
  }
  .el-drawer__body {
    padding: 0;
  }
}
/deep/.el-radio{
  border-color: #C1C1C1;
  color: #666;
  .el-radio__inner{
    border-color: #C1C1C1;
  }
}
/deep/.el-radio.is-bordered.is-checked{
  border-color: #0FC29A;
  .el-radio__label{
    color: #0FC29A;
  }
  .el-radio__inner{
    border-color: #0FC29A;
    background: #0FC29A;
  }
}

/deep/.el-upload--picture-card{
  width: 74px;
  height: 74px;
  line-height: 74px;
}
/deep/.el-upload-list--picture-card{
  .el-upload-list__item{
    width: 74px;
    height: 74px;
  }
}
/deep/.upload-limit{
  .el-upload--picture-card{
    display: none;
  }
}
/* 弹窗样式 start */
.drawerMain-box {
  text-align: left;
  height: 100%;
  overflow: auto;
  padding: 20px 30px;
  .block-label {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .tips {
    font-size: 14px;
    margin-bottom: 8px;
  }
  .quote-txt {
    margin-bottom: 20px;
    padding: 16px;
    height: auto;
    max-height: 78px;
    font-size: 16px;
    line-height: 28px;
    background: #f2f2e7;
    border-radius: 6px;
  }
  /deep/.quote-txt.quote-txt-2 {
    padding: 10px 16px;
    background: #f1f1f1;
    border: 1px dashed #4f678e;
    border-radius: 2px;
    max-height: 54px;
    font-size: 14px;
    margin-bottom: 10px;
  }
  /deep/.upload-img-box {
    display: flex;
    align-items: flex-start;
    > .el-upload-list__item {
      margin: 0 8px 8px 0;
      width: 80px;
      height: 80px;
      border-radius: 6px;
      overflow: hidden;
      border: 1px solid #c0ccda;
      display: flex;
      img {
        width: 100%;
      }
    }
  }
  .writeNote-textarea {
    padding: 10px;
    margin-bottom: 20px;
    width: 100%;
    min-height: 100px;
    height: 150px;
    font-size: 16px;
    font-family: unset;
    color: #2f4058;
    border-radius: 6px;
    line-height: 28px;
    border: 1px solid #c1c1c1;
    -moz-user-select: auto !important; /*火狐*/
    -webkit-user-select: auto !important; /*webkit浏览器*/
    -ms-user-select: auto !important; /*IE10*/
    -khtml-user-select: auto !important; /*早期浏览器*/
    user-select: auto !important;
    list-style: auto !important;
    outline: none;
  }
  .writeNote-textarea:focus {
    border: 1px solid #0FC29A;
  }
  .btn-box {
    width: 100%;
    /*text-align: center;*/
    .btn {
      width: 200px;
      margin: 0 auto;
      border: none;
      height: 40px;
      font-size: 16px;
      color: #f9f9f9;
      text-align: center;
      line-height: 40px;
      background: #0FC29A;
      border-radius: 4px;
      cursor: pointer;
    }
    .btn:hover {
      opacity: 0.9;
      color: #fff;
    }
    .btn.cancel-btn {
      margin-left: 20px;
      width: 120px;
      background: #B1B1B1;
    }
  }
}
/* 记笔记弹窗样式 end */
</style>